import styled from 'styled-components'

const MyDiv = styled.div`
.card {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    background: #fff;
    padding: 12px 6px 6px 6px;
    box-shadow:  0px 4px 4px 0px #00000040;
  }
    .tab-list-container {
    flex-grow: 1;
    overflow-x: auto;
  }
 .btn {
    background:rgba(0, 104, 56, 1);
    color:white;
    &:hover{
    background:rgba(0, 104, 56, 1);
    color:white;
  }
}
.badge{
  padding: 4px 4px; 
  border-radius: 8px;
  font-weight: 500; 
}
  .page_wrapper {
     padding-top: 8px;
  }
   .job {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    white-space: nowrap; 
    cursor: pointer;
  }
 .card_box {
  background: white;
  border-radius: 12px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  width: auto;
}
  .donut-chart {
    width: 280px;
    height: 250px;
  }
.card-wrapper{
    background: #EEF3FB;
    border-radius: 8px;
}
.legend-row {
    width: 100%;
  }
  

.page_heading {
  margin-bottom: 24px;
}

.flex_header {
  align-items: center;
  justify-content: space-between;
}
.content{
 filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}


.card_box {
  background: white;
  padding: 5px 10px;
  border-radius: 16px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.card_label {
  color: #23272E;
}

.card_value {
font-size: 36px;
  color: #23272E;
}
    .icon_btn {
   min-width: 40px;
    cursor: pointer;  
  }
`
export default MyDiv
